export enum WidgetTypeEnum {
  NumberWidget = 'NumberWidget',
  PieChartWidget = 'PieChartWidget',
  TableWidget = 'TableWidget',
  MapWidget = 'MapWidget',
  MetricsAverageWidget = 'MetricsAverageWidget',
  CounterWidget = 'CounterWidget'
}
